import axios from 'axios';
import Cookies from 'js-cookie';
import BaseApi from 'Components/api/BaseApi';
import { ApiKey, HttpClient } from 'shared/libs/http';
import { AppliedJobsIndexResponse } from './types';

export class AppliedJobsApiService {
   public static async loadAppliedJobs() {
      return await HttpClient.post<AppliedJobsIndexResponse>('/job/applied', null);
   }

   public static async downloadAppliedFile(fileId: number) {
      const token = Cookies.get('tokenClient');
      return await axios.get<Blob>(`${BaseApi}/jobApply/downloadFile/${fileId}`, {
         headers: {
            key: ApiKey,
            token,
         },
         responseType: 'blob',
      });
   }
}

